import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Gift } from "lucide-react";

export function GiftBanner() {
  const [banner, setBanner] = useState(null);
  useEffect(() => {
    api.get("/settings/gift-banner").then(({ data }) => setBanner(data)).catch(() => {});
  }, []);
  if (!banner?.enabled || !banner?.text) return null;
  return (
    <Link to="/gift" data-testid="gift-banner"
      className="block bg-coral text-white text-center text-sm font-medium px-4 py-2.5 hover:bg-coraldark transition-colors">
      <span className="inline-flex items-center gap-2 flex-wrap justify-center">
        <Gift size={15} /> {banner.text} <span className="underline">Give a gift →</span>
      </span>
    </Link>
  );
}
